import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useUser } from '../../context/User/useUser';
import { isAdmin } from '../../helpers/user';
import { SignOut } from '../../pages/Projects/Projects.styles';
import { Flex } from '../Flex/Flex';
import { Sizing } from '../../styles/spacing';
import { FontSize } from '../../styles/typography';
import { Text } from '../Text/Text';

const NavbarContainer = styled.div`
  margin-top: -10px;
  margin-bottom: 20px;
`;

export const Navbar = () => {
  const user = useUser();
  const { pathname } = useLocation();
  return (
    <NavbarContainer>
      {isAdmin(user) && pathname !== '/settings' && (
        <Flex $mb={Sizing.lg} $flexDirection="column" $alignItems="flex-start">
          <Text $fontSize={FontSize.sm} $color="#5e5f61">
            <b>
              <FormattedMessage id="navbar.adminLabel" />
            </b>{' '}
            <Link to={'/'}>
              <FormattedMessage id="navbar.adminStart" />
            </Link>
            {' • '}
            <Link to={'/admin/projects'}>
              <FormattedMessage id="navbar.adminProjects" />
            </Link>
            {' • '}
            <Link to={'/admin/users'}>
              <FormattedMessage id="navbar.adminUsers" />
            </Link>
          </Text>
        </Flex>
      )}

      <Flex
        $gap={Sizing.sm}
        $flexDirection="row"
        $alignItems="flex-start"
        $justifyContent="space-between"
      >
        <Flex $flexDirection="column">
          <Text $fontSize={FontSize.sm} $color="var(--text-muted)">
            <FormattedMessage
              id="navbar.loggedInAs"
              values={{ name: user.name }}
            />
          </Text>
          {pathname !== '/settings' && (
            <Text $fontSize={FontSize.sm}>
              <Link to="/settings">
                <FormattedMessage id="navbar.accountSettings" />
              </Link>
            </Text>
          )}
        </Flex>
        <Text $textAlign="right">
          <SignOut onClick={user.signOut}>
            <FormattedMessage id="navbar.signOut" />
          </SignOut>
        </Text>
      </Flex>
    </NavbarContainer>
  );
};
